import ArrowDownSvg from '@/assets/ArrowDownSvg.svg';
import InterestedRobotSvg from '@/assets/InterestedRobotSvg.svg';
import { generateNonCachableImageSrc } from '@/utils/generateNonCachableImageSrc.util.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import React from 'react';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import { IoCloseSharp } from 'react-icons/io5';

interface Props {
  onCloseConfirmation: () => void;
  onResendClick: () => void;
  resendDone: boolean;
  visible: boolean;
}

const EmailConfirmationDesktop: React.FC<Props> = ({
  onCloseConfirmation,
  onResendClick,
  resendDone,
  visible,
}) => {
  const { t } = useTranslationWithPrefix('welcomePage.popup');

  if (!visible) {
    return <></>;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div style={{ position: 'absolute', right: '20px', top: '20px', zIndex: 60 }}>
        <IoCloseSharp
          color="black"
          onClick={onCloseConfirmation}
          size="32"
          style={{ cursor: 'pointer' }}
        />
      </div>
      <div className="fixed inset-0 bg-white/50 backdrop-blur-[15px] h-[200%]" />
      <div className="bg-gray-100 pt-[22px] pl-[38px] pb-[32px] pr-[30px] shadow-lg z-10 w-[520px] mx-4 relative">
        <div className="flex flex-col gap-m">
          <AiOutlineInfoCircle size="32" />
          <p className="display-4 text-primary ">{t('message')}</p>
          <p className="lead">{t('subMessage')}</p>
          {resendDone ? (
            <span className="text-primary">{t('resendEmailSent')}</span>
          ) : (
            <p className="small pt-2">
              {t('emailNotReceived1')}
              <button className="btn btn-link" onClick={onResendClick} type="button">
                <span className="small fw-bold pb-[2px]">{t('emailNotReceivedHere')}</span>
              </button>
              {t('emailNotReceived2')}
            </p>
          )}
        </div>
        <img
          alt="arrow-down"
          className="w-14 absolute -z-10 -bottom-10 left-1/2 transform -translate-x-1/2"
          src={ArrowDownSvg}
        />
      </div>
      <div className="absolute mt-80 mr-220">
        <img alt="popup-robot" src={generateNonCachableImageSrc(InterestedRobotSvg)} />
      </div>
    </div>
  );
};

export default EmailConfirmationDesktop;
